import { render, staticRenderFns } from "./privacyTiger.vue?vue&type=template&id=185d6864&scoped=true"
import script from "./privacyTiger.vue?vue&type=script&lang=js"
export * from "./privacyTiger.vue?vue&type=script&lang=js"
import style0 from "./privacyTiger.vue?vue&type=style&index=0&id=185d6864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d6864",
  null
  
)

export default component.exports